import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  // 首页
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  // 注册
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index.vue')
    },
  // 查案例
  {
    path:'/case_condition',
    name:"CaseCondition",
    component:() => import('@/views/search/Case/searchCase_02.vue'),
    // meta: {
    //   keepAlive: true    //开启缓存
    // }
  },
  {
    path:'/case',
    name:"Case",
    component:() => import('@/views/search/Case/searchCase.vue'),
    // meta: {
    //   keepAlive: true    //开启缓存
    // }
  },
  // 案例详情
  {
    path:'/detail/:id',
    name:"Detail",
    component:() => import('@/views/search/Case/Detail/detail.vue')
  },
  // 原文
  {
    path:'/original/:id',
    name:"original",
    component:() => import('@/views/search/Case/Detail/original.vue')
  },
  // 搜律所
  {
    path:'/lawFirm',
    name:"LawFirm",
    component:() => import('@/views/search/Law/lawFirm.vue')
  },
  // 律所详情
  {
    path:'/lawsDetail',
    name:"LawsDetails",
    component:() => import('@/views/search/Law/detail/lawDetail.vue')
  },
  // 法律法规
  {
    path:'/lawsStatute',
    name:"LawsStatute",
    component:() => import('@/views/search/lawsStatute/lawsStatute.vue')
  },
  // 法律法规详情
  {
    path:'/lawsDetail/:id',
    name:"LawsDetail",
    component:() => import('@/views/search/lawsStatute/component/lawsDetail.vue')
  },
  // 个人中心
  {
    path:'/personal',
    name:"Personal",
    component:() => import('@/views/Personal/personal.vue')
  },
  // 搜企业首页
  {
    path:'/companiesHome',
    name:"CompaniesHome",
    component:() => import('@/views/search/Companies/companiesHome.vue')
  },
  // 搜企业
  {
    path:'/companies',
    name:"Companies",
    component:() => import('@/views/search/Companies/companies.vue')
  },
  // 搜企业详情
  {
    path:'/companiesDetails/:id',
    name:"CompaniesDetails",
    component:() => import('@/views/search/Companies/component/companiesDetails.vue')
  },
  // 搜全文
  {
    path:'/transcript',
    name:"Transcript",
    component:() => import('@/views/search/Transcript/transcript.vue')
  },
  // 案例高级检索
  {
    path:'/advanced',
    name:"Advanced",
    component:() => import('@/views/search/Advanced/advancedSearch.vue')
  },
  // // 法律法规高级检索
  {
    path:'/advancedLaws',
    name:"AdvancedLaws",
    component:() => import('../views/search/Advanced/advancedLaws.vue')
  },
  // 404
  {
    path: '/*',
    name: '404',
    component: () => import('@/views/404/index.vue')
  },
]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  if (to.path === '/') {
      next()
  } else if (to.path !== '/' && !store.getCookie("token_S")) {
    return next('/')
  }else{
    next()
  }

})


export default router
